import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import HeroSection from "./components/Hero";
import ServicesSection from "./components/ServiceSection";
import Footer from "./components/Footer";
import ContactUs from "./components/ContactUs";
import AboutUs from "./components/AboutUs";
import ContigentStaffing from "./components/ContigentStaffing";
import DirectHire from "./components/DirectHire";
import GlobalPayroll from "./components/GlobalPayroll";
import NearshoreOnshore from "./components/NearshoreOnshore";
import RPO from "./components/RPO";
import SOW from "./components/SOW";
function App() {
  return (
    <div>
      <Header />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <HeroSection />
              <ServicesSection />
            </>
          }
        />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contingent-staffing" element={<ContigentStaffing />} />
        <Route path="/direct-hire" element={<DirectHire />} />
        <Route path="/nearshore-onshore" element={<NearshoreOnshore />} />
        <Route path="/global-payroll-compliance" element={<GlobalPayroll />} />
        <Route path="/recruitment-process-outsourcing" element={<RPO />} />
        <Route path="/statement-of-work" element={<SOW />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
